import { library } from '@fortawesome/fontawesome-svg-core';

import {
     faCode,
      faMoneyBill, 
      faHighlighter,
      faStroopwafel,
      faSpinner,
      faLock, 
      faScaleBalanced,
      faWallet,
      faWaveSquare,
      faRotateForward
    } from "@fortawesome/free-solid-svg-icons";

import {
       faFacebook, 
       faInstagram, 
       faSpotify, 
       faTwitter
     } from "@fortawesome/free-brands-svg-icons";



library.add(
    faCode, 
    faMoneyBill,
    faHighlighter,
    faStroopwafel,
    faSpinner,
    faFacebook,
    faInstagram,
    faSpotify,
    faTwitter,
    faLock,
    faScaleBalanced,
    faWallet,
    faWaveSquare,
    faRotateForward

    
);



